(() => {
  'use strict';
  const popup = document.getElementById('nzc-labour-sale-2026');
  if (!popup || typeof popup.showModal !== 'function') return;
  const key = 'nzc-labour-sale-2026-seen';
  const start = Date.parse(popup.dataset.saleStart);
  const end = Date.parse(popup.dataset.saleEnd);
  const active = () => Date.now() >= start && Date.now() <= end;
  if (!active()) return;
  try { if (sessionStorage.getItem(key)) return; } catch (_) {}
  let pending = false;
  const events = ['scroll', 'pointerdown', 'keydown'];
  const stop = () => events.forEach(name => window.removeEventListener(name, trigger));
  const close = () => { if (popup.open) popup.close(); };
  function trigger() {
    if (pending) return;
    pending = true;
    window.setTimeout(() => {
      pending = false;
      if (!active()) { stop(); return; }
      if (document.visibilityState === 'hidden' || document.querySelector('dialog[open], [aria-modal="true"]')) return;
      stop();
      popup.showModal();
      document.documentElement.classList.add('nzc-labour-open');
      try { sessionStorage.setItem(key, '1'); } catch (_) {}
      window.setTimeout(close, Math.min(end - Date.now() + 1, 2147483647));
    }, 800);
  }
  popup.querySelectorAll('[data-labour-close]').forEach(button => button.addEventListener('click', close));
  popup.querySelector('.nzc-labour-shop').addEventListener('click', close);
  popup.addEventListener('close', () => document.documentElement.classList.remove('nzc-labour-open'));
  popup.addEventListener('click', event => {
    if (event.target !== popup) return;
    const rect = popup.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
  });
  events.forEach(name => window.addEventListener(name, trigger, { passive: true }));
})();
